import { defineComponent as _defineComponent } from 'vue'
import { useI18n } from 'vue-i18n-composable'
import FormComponent from '@/components/forms/loginForm/FormComponent.vue'
import useEasterEgg from '@/composables/useEasterEgg'
import HelpContainerComponent from '@/components/forms/loginForm/HelpInfoComponent.vue'
import { useVuetify } from '@/composables/useVuetify'
import { onMounted } from 'vue'
// import useSpinner from '@/composables/useSpinner'

// TRANSLATIONS

export default /*#__PURE__*/_defineComponent({
  __name: 'LoginFormComponent',
  setup(__props) {

const { t } = useI18n()
const text = {
  intro: t('views.login.intro'),
  product: t('views.login.product')
}

// COMPOSABLES
const { isMobileBreakpoint } = useVuetify()
// const { hideSpinnerLayer } = useSpinner()

const { isValid } = useEasterEgg({
  code: 'lexondevcallsaul'
})

// HOOKS
onMounted(() => {
  // hideSpinnerLayer()
})

return { __sfc: true,t, text, isMobileBreakpoint, isValid, FormComponent, HelpContainerComponent }
}

})